module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tab-item tab-pane",
    class: {
      active: _vm.active
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09376245","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabset/tab-item.vue
// module id = 33
// module chunks = 0